import React from 'react';
import { AccordionItem } from './ui/Accordion';
import { Badge } from './ui/Badge';
import { DownloadIcon } from 'lucide-react';
import { Button } from './ui/Button';
export function RequirementsAccordion() {
  return <section id="requisitos" className="py-20 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-179">
      <div className="max-w-4xl mx-auto" data-id="element-180">
        <div className="text-center mb-12" data-id="element-181">
          <Badge variant="primary" className="mb-4" data-id="element-182">
            Requisitos
          </Badge>
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4" data-id="element-183">
            ¿Qué necesitas para aplicar?
          </h2>
          <p className="text-xl text-slate-600" data-id="element-184">
            Solo pedimos lo necesario. Aprobación en menos de 48 horas.
          </p>
        </div>

        <div className="space-y-4 mb-8" data-id="element-185">
          <AccordionItem title="Persona Moral (Empresas)" defaultOpen data-id="element-186">
            <div className="space-y-4" data-id="element-187">
              <div data-id="element-188">
                <h4 className="font-semibold text-slate-900 mb-2" data-id="element-189">
                  Documentos esenciales:
                </h4>
                <ul className="space-y-2" data-id="element-190">
                  <li className="flex items-start gap-2" data-id="element-191">
                    <svg className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20" data-id="element-192">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-193" />
                    </svg>
                    <span className="text-slate-700" data-id="element-194">
                      Acta constitutiva y poderes del representante legal
                    </span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-195">
                    <svg className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20" data-id="element-196">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-197" />
                    </svg>
                    <span className="text-slate-700" data-id="element-198">
                      Estados financieros de los últimos 2 años
                    </span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-199">
                    <svg className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20" data-id="element-200">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-201" />
                    </svg>
                    <span className="text-slate-700" data-id="element-202">
                      Comprobante de domicilio fiscal (no mayor a 3 meses)
                    </span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-203">
                    <svg className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20" data-id="element-204">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-205" />
                    </svg>
                    <span className="text-slate-700" data-id="element-206">
                      Identificación oficial del representante legal
                    </span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-207">
                    <svg className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20" data-id="element-208">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-209" />
                    </svg>
                    <span className="text-slate-700" data-id="element-210">
                      Constancia de situación fiscal actualizada
                    </span>
                  </li>
                </ul>
              </div>

              <div className="bg-primary-50 rounded-lg p-4" data-id="element-211">
                <p className="text-sm text-primary-900" data-id="element-212">
                  <span className="font-semibold" data-id="element-213">Nota:</span> Para montos
                  mayores a $2M MXN, podríamos solicitar documentación
                  adicional.
                </p>
              </div>
            </div>
          </AccordionItem>

          <AccordionItem title="Persona Física con Actividad Empresarial" data-id="element-214">
            <div className="space-y-4" data-id="element-215">
              <div data-id="element-216">
                <h4 className="font-semibold text-slate-900 mb-2" data-id="element-217">
                  Documentos esenciales:
                </h4>
                <ul className="space-y-2" data-id="element-218">
                  <li className="flex items-start gap-2" data-id="element-219">
                    <svg className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20" data-id="element-220">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-221" />
                    </svg>
                    <span className="text-slate-700" data-id="element-222">
                      Identificación oficial vigente
                    </span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-223">
                    <svg className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20" data-id="element-224">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-225" />
                    </svg>
                    <span className="text-slate-700" data-id="element-226">
                      Comprobante de domicilio (no mayor a 3 meses)
                    </span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-227">
                    <svg className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20" data-id="element-228">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-229" />
                    </svg>
                    <span className="text-slate-700" data-id="element-230">
                      Declaraciones anuales de los últimos 2 años
                    </span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-231">
                    <svg className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20" data-id="element-232">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-233" />
                    </svg>
                    <span className="text-slate-700" data-id="element-234">
                      Constancia de situación fiscal
                    </span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-235">
                    <svg className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20" data-id="element-236">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-237" />
                    </svg>
                    <span className="text-slate-700" data-id="element-238">
                      Estados de cuenta bancarios (últimos 3 meses)
                    </span>
                  </li>
                </ul>
              </div>

              <div className="bg-success/10 rounded-lg p-4" data-id="element-239">
                <p className="text-sm text-slate-900" data-id="element-240">
                  <span className="font-semibold" data-id="element-241">Ventaja:</span> Proceso más
                  ágil para profesionistas independientes y pequeños negocios.
                </p>
              </div>
            </div>
          </AccordionItem>
        </div>

        <div className="text-center" data-id="element-242">
          <Button variant="outline" size="lg" data-id="element-243">
            <DownloadIcon className="w-5 h-5" data-id="element-244" />
            Descargar checklist completo (PDF)
          </Button>
          <p className="text-sm text-slate-600 mt-4" data-id="element-245">
            ¿Tienes dudas sobre los requisitos?{' '}
            <a href="#contacto" className="text-primary font-semibold hover:underline" data-id="element-246">
              Habla con un asesor
            </a>
          </p>
        </div>
      </div>
    </section>;
}